module.exports = __webpack_public_path__ + "img/buddy_ears-01.6ac356d5.svg";